import script from "./DaumPostcodeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DaumPostcodeModal.vue?vue&type=script&setup=true&lang=js"

import "./DaumPostcodeModal.vue?vue&type=style&index=0&id=e672c574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e672c574"]])

export default __exports__